import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import {
  loadAdminKey,
  loadVisitorId,
  setCookieConsent,
} from "../store/appReducer";
import cuid from "cuid";
import { signOutUser } from "../../features/auth/authActions";
import { signOutFirebase } from "../../app/firestore/firebaseService";

export const HELLO_RADIUS_COOKIE = "_hr_ca";

const VIEWS_SESSION_ID_COOKIE = "_hr_vsid";
export const ONE_DAY = 86400;

export const ADMIN_KEY_COOKIE = "_hr_admin";
export const ADMIN_ACCESS_KEY = "w*YMw*EYd*N62nhhg";

export default function CookieWrapper({ children }) {
  const dispatch = useDispatch();
  const [cookies, setCookie, removeCookie] = useCookies();

  const isCookieConsent = cookies[HELLO_RADIUS_COOKIE] === "1";

  const isViewsSessionId = cookies[VIEWS_SESSION_ID_COOKIE];

  const isAdminKey = cookies[ADMIN_KEY_COOKIE] === ADMIN_ACCESS_KEY;

  useEffect(() => {
    if (isCookieConsent) {
      dispatch(setCookieConsent(true));
    } else if (!cookies[HELLO_RADIUS_COOKIE]) {
      // admins - no cookies for GA
      dispatch(setCookieConsent(true));
      // dispatch(openModal({ modalType: COOKIE_CONSENT_MODAL }));
    }
  }, [cookies, dispatch, isCookieConsent]);

  useEffect(() => {
    if (isViewsSessionId) {
      dispatch(loadVisitorId(isViewsSessionId));
    } else {
      const viewsSessionId = cuid();
      setCookie(VIEWS_SESSION_ID_COOKIE, viewsSessionId, {
        path: "/",
        maxAge: ONE_DAY,
      });
    }
  }, [isViewsSessionId, dispatch, setCookie]);

  useEffect(() => {
    if (isAdminKey) {
      dispatch(loadAdminKey(true));
    } else {
      removeCookie(ADMIN_KEY_COOKIE);
      dispatch(loadAdminKey(false));
      dispatch(signOutUser());
      signOutFirebase();
    }
  }, [dispatch, isAdminKey, removeCookie]);

  return <div className="cookie-wrapper">{children}</div>;
}
